import { ContributionType } from './data';

export const SUPPORT_EMAIL = 'support@betterment.com';
export const SUPPORT_NUMBER = '(646) 600-8263';
export const CHECKING_SUPPORT_PHONE = '718-400-6898';
export const MFA_LOCKED_SUPPORT_PHONE = '(512) 900-2438';
export const OPS_LOCKED_EMAIL = 'accountsecurity@betterment.com';
export const CASH_SUPPORT_EMAIL = 'cashsupport@betterment.com';
export const US_STATES = {
  AA: 'Armed Forces America',
  AE: 'Armed Forces Europe',
  AL: 'Alabama',
  AK: 'Alaska',
  AP: 'Armed Forces Pacific',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};
export const IRA_CONTRIBUTION_CALCULATOR_URL =
  'https://www.irs.gov/retirement-plans/amount-of-roth-ira-contributions-that-you-can-make-for-2019';

export const DEFAULT_CONTRIBUTION_TYPE: ContributionType = 'tax_year_contribution';
export const DEFAULT_FEDERAL_WITHHOLDING_PERCENT = '10';
export const BACKUP_WITHHOLDING_PERCENT = 24;

interface CountryCode {
  [key: string]: string;
}
// List of ISO 3166-1 alpha-2 country codes
export const COUNTRY_CODES: CountryCode = {
  AL: 'Albania',
  BZ: 'Belize',
  DZ: 'Algeria',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AX: 'Åland Islands',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  AW: 'Aruba',
  BS: 'Bahamas',
  BH: 'Bahrain',
  AU: 'Australia',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BW: 'Botswana',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  KY: 'Cayman Islands',
  BT: 'Bhutan',
  BM: 'Bermuda',
  BV: 'Bouvet Island',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  KH: 'Cambodia',
  VI: 'Virgin Islands (U.S.)',
  CM: 'Cameroon',
  BI: 'Burundi',
  CA: 'Canada',
  CV: 'Cabo Verde',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CL: 'Chile',
  CG: 'Congo',
  CN: 'China',
  CK: 'Cook Islands',
  TD: 'Chad',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  HR: 'Croatia',
  DK: 'Denmark',
  CU: 'Cuba',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  GQ: 'Equatorial Guinea',
  FJ: 'Fiji',
  FI: 'Finland',
  GL: 'Greenland',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GE: 'Georgia',
  DE: 'Germany',
  GF: 'French Guiana',
  GH: 'Ghana',
  GM: 'Gambia',
  GI: 'Gibraltar',
  GR: 'Greece',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GY: 'Guyana',
  GP: 'Guadeloupe',
  HT: 'Haiti',
  GU: 'Guam',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See',
  HN: 'Honduras',
  IN: 'India',
  CI: "Côte d'Ivoire",
  IR: 'Iran(Islamic Republic of)',
  IQ: 'Iraq',
  HU: 'Hungary',
  IE: 'Ireland',
  IS: 'Iceland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  PW: 'Palau',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  JO: 'Jordan',
  LV: 'Latvia',
  JP: 'Japan',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  LS: 'Lesotho',
  MG: 'Madagascar',
  LR: 'Liberia',
  MW: 'Malawi',
  MT: 'Malta',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MV: 'Maldives',
  YT: 'Mayotte',
  ML: 'Mali',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (Republic of)',
  MS: 'Montserrat',
  MA: 'Morocco',
  MM: 'Myanmar',
  NA: 'Namibia',
  MN: 'Mongolia',
  NR: 'Nauru',
  ME: 'Montenegro',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NE: 'Niger',
  NO: 'Norway',
  NI: 'Nicaragua',
  OM: 'Oman',
  PK: 'Pakistan',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PG: 'Papua New Guinea',
  PN: 'Pitcairn',
  PA: 'Panama',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RW: 'Rwanda',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  SG: 'Singapore',
  BL: 'Saint Barthélemy',
  RE: 'Réunion',
  RO: 'Romania',
  SM: 'San Marino',
  SA: 'Saudi Arabia',
  VC: 'Saint Vincent and the Grenadines',
  SN: 'Senegal',
  RS: 'Serbia',
  WS: 'Samoa',
  SC: 'Seychelles',
  ST: 'Sao Tome and Principe',
  SL: 'Sierra Leone',
  SB: 'Solomon Islands',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  KR: 'Korea (Republic of)',
  SK: 'Slovakia',
  SS: 'South Sudan',
  SI: 'Slovenia',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SZ: 'Swaziland',
  SR: 'Suriname',
  SE: 'Sweden',
  SJ: 'Svalbard and Jan Mayen',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  CH: 'Switzerland',
  TZ: 'Tanzania, United Republic of',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TG: 'Togo',
  TM: 'Turkmenistan',
  TV: 'Tuvalu',
  TK: 'Tokelau',
  UG: 'Uganda',
  TO: 'Tonga',
  UA: 'Ukraine',
  UY: 'Uruguay',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  UZ: 'Uzbekistan',
  WF: 'Wallis and Futuna',
  GB: 'United Kingdom of Great Britain and Northern Ireland',
  EH: 'Western Sahara',
  ZW: 'Zimbabwe',
  AF: 'Afghanistan',
  AS: 'American Samoa',
  AM: 'Armenia',
  BJ: 'Benin',
  BA: 'Bosnia and Herzegovina',
  UM: 'United States Minor Outlying Islands',
  CF: 'Central African Republic',
  ZM: 'Zambia',
  CR: 'Costa Rica',
  EG: 'Egypt',
  FR: 'France',
  GD: 'Grenada',
  GW: 'Guinea-Bissau',
  HK: 'Hong Kong',
  ID: 'Indonesia',
  JM: 'Jamaica',
  JE: 'Jersey',
  LB: 'Lebanon',
  MH: 'Marshall Islands',
  MC: 'Monaco',
  MZ: 'Mozambique',
  NZ: 'New Zealand',
  PS: 'Palestine, State of',
  XK: 'Republic of Kosovo',
  RU: 'Russian Federation',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  BO: 'Bolivia (Plurinational State of)',
  VG: 'Virgin Islands (British)',
  SO: 'Somalia',
  SD: 'Sudan',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TC: 'Turks and Caicos Islands',
  AE: 'United Arab Emirates',
  YE: 'Yemen',
  CD: 'Congo (Democratic Republic of the)',
  SV: 'El Salvador',
  PF: 'French Polynesia',
  MK: 'Macedonia (the former Yugoslav Republic of)',
  MY: 'Malaysia',
  KP: "Korea (Democratic People's Republic of) ",
  SX: 'Sint Maarten(Dutch part)',
  US: 'United States of America',
};
